import React from "react";

// Chakra imports
import { Flex } from "@chakra-ui/react";

// Custom components
import { BeetLogo } from "components/icons/Icons";
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {

  return (
    <Flex align='center' direction='column'>
      <BeetLogo h='32px' w='78px' my='23px' />
      <HSeparator mb='20px' />
    </Flex>
  );
}

export default SidebarBrand;
